"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var AuthScope_1 = require("./enums/AuthScope");
var ScopeClientUrl_1 = require("./enums/ScopeClientUrl");
var ScopeIconUrl_1 = require("./enums/ScopeIconUrl");
var ScopeLabel_1 = require("./enums/ScopeLabel");
var scopes = [
    AuthScope_1.default.AUTH,
    AuthScope_1.default.ADVERTISERS,
    AuthScope_1.default.ALGOTRADER,
    AuthScope_1.default.AUTOSCALER,
    AuthScope_1.default.BI_DASHBOARD,
    AuthScope_1.default.BI_DASHBOARDS,
    AuthScope_1.default.CAMPAIGN_DUPLICATOR,
    AuthScope_1.default.CAPCHU,
    AuthScope_1.default.CAPTAINS_LOG,
    AuthScope_1.default.CONNECTIONS,
    AuthScope_1.default.CONTENT,
    AuthScope_1.default.GAMES,
    AuthScope_1.default.MESSAGES,
    AuthScope_1.default.MONEY_BOOKER,
    AuthScope_1.default.NIGHTWATCH,
    AuthScope_1.default.OPEN_RTB,
    AuthScope_1.default.PLATFORM,
    AuthScope_1.default.PUBLISHERS,
    AuthScope_1.default.REPORTING,
    AuthScope_1.default.SKYNET,
    AuthScope_1.default.VAULT,
    AuthScope_1.default.VROKU,
    AuthScope_1.default.WEB_DIRECTORY,
    AuthScope_1.default.SITES,
    AuthScope_1.default.FEATURE_TOGGLES,
    AuthScope_1.default.USER_NOTIFICATIONS,
    /**
     * External Scopes
     */
    AuthScope_1.default.KIBANA,
];
var manifest = {};
var scope;
for (var i = 0, len = scopes.length; i < len; i++) {
    scope = scopes[i];
    manifest[scope] = {
        scope: scope,
        displayName: ScopeLabel_1.default[scope] || "",
        clientUrl: ScopeClientUrl_1.default[scope] || "",
        iconUrl: ScopeIconUrl_1.default[scope] || ""
    };
}
exports.default = manifest;
